<accordion>
  @for (item of collateralNotes; track item; let i = $index) {
    <accordion-group class="list-accounts" #accGroup [hidden]="item.collateralNoteStatus === 'INACTIVE'"
      [isOpen]="accGroup?.isOpen || isExpanded(item)">
      <span accordion-heading>
        <div class="account-items font-13 d-flex align-items-center {{ item.subCollateralNotes.length == 0?'last-level':''}}">
          @if (item.subCollateralNotes.length !== 0) {
            <button class="btn" type="button" id="{{item.id}}">
              <em class="fa font-25"
                [ngClass]="{'fa-minus-square-o': accGroup?.isOpen, 'fa-plus-square-o': !accGroup?.isOpen}">
              </em>
            </button>
          }
          <span class="account-parent-name mt-10 level-{{level}} font-bold" id="level-{{level}}"
            [ngClass]="{'pl-5': item.subCollateralNotes.length === 0}">
            {{item.name}}
          </span>
          <input
            type="checkbox"
            (click)="$event.stopPropagation()"
            (change)="changeNoteStatus(item, $event)"
            class="account-checkbox"
            [disabled]="item.mandatory"
            [checked]="isSelectedCollateralNote(item)"
            [indeterminate]="isIndeterminate(item)">
          </div>
        </span>
        @if (item.subCollateralNotes.length !== 0) {
          <div>
            <app-collateral-note-node
              [collateralNotes]="item.subCollateralNotes"
              [selectedCollateralNotes]="selectedCollateralNotes"
              [level]="(level || 0) + 1"
              (onAddCollateralNote)="addCollateralNote($event)"
              (onDeleteCollateralNote)="deleteCollateralNote($event)">
            </app-collateral-note-node>
          </div>
        }
      </accordion-group>
    }
  </accordion>
